import React from 'react'
import PropTypes from 'prop-types'

import NavLink from '@/ui/NavLink'
import Button from '@/ui/Button/Button'
import Avatar from '@/ui/Avatar/Avatar'
import ClickAwayListener from '@/ui/ClickAwayListener'
import classNames from '@/helpers/classNames'

import PlaneIcon from '@/icons/Mail'
import Logo from '@/media/svg/logo.svg'

import { userLogout } from '@/state/actions/auth'
import { routeNewslettersNew, goToPage } from '@/state/actions/routes'
import { ROUTE_USERS_EDIT } from '@/state/types/routes'

class AppBar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    theme: PropTypes.object.isRequired,
  }

  state = {
    userMenuOpen: false,
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.userMenuOpen !== prevState.userMenuOpen) {
      requestAnimationFrame(() => {
        // Hack to force animation after dom update
        // https://stackoverflow.com/questions/26556436/react-after-render-code
        setTimeout(() => {
          this.userMenuNode.classList.toggle('active')
        }, 0)
      })
    }
  }

  logout = () => {
    this.props.dispatch(userLogout())
  }

  openUserMenu = open => {
    this.setState({ userMenuOpen: !this.state.userMenuOpen })
  }

  clickAwayMenu = () => {
    if (this.state.userMenuOpen) {
      this.openUserMenu(false)
    }
  }

  gotoBuild = () => {
    this.props.dispatch(routeNewslettersNew())
  }

  gotoAccount = () => {
    this.setState({ userMenuOpen: false })
    this.props.dispatch(goToPage(ROUTE_USERS_EDIT, null, { id: this.props.user.id }))
  }

  animateUnderLine() {
    // I know, I know .. but I refuse to choose semantics over performance
    setTimeout(() => {
      if (!this.navigationNode) {
        return
      }
      const nav = this.navigationNode.getBoundingClientRect()
      let currentName = this.props.routesMap[this.props.currentRouteType].name
      let node = this.navigationNode.querySelector(`[data-title="${currentName}"]`)
      let label
      if (node) {
        label = node.getBoundingClientRect()
      } else {
        currentName = this.props.routesMap[this.props.routesMap[this.props.currentRouteType].parent]
          .name
        node = this.navigationNode.querySelector(`[data-title="${currentName}"]`)
        if (!node) {
          return
        }
        label = node.getBoundingClientRect()
      }
      this.underlineNode.style.top = `${nav.height}px`
      this.underlineNode.style.left = `${label.left - nav.left}px`
      this.underlineNode.style.width = `${label.width}px`
    }, 0)
  }

  getInitials = string => {
    const names = string.split(' ')
    let initials = names[0].substring(0, 1).toUpperCase()

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase()
    } else {
      initials += names[0].substring(1, 2).toUpperCase()
    }
    return initials
  }

  render() {
    const { theme, currentRouteType, user, ...props } = this.props
    const routes = Object.keys(props.routesMap)
    if (this.currentRouteType !== currentRouteType) {
      this.currentRouteType = this.props.currentRouteType
      this.animateUnderLine()
    }
    const initials = user ? this.getInitials(user.full_name) : ''

    return (
      <nav className={classNames(theme, 'app-bar')}>
        <ul
          className={classNames(theme, 'app-bar-nav')}
          role="tablist"
          ref={node => {
            this.navigationNode = node
          }}
        >
          <li className={classNames(theme, 'app-bar-nav-item', 'app-bar-logo')}>
            <Logo width="32" height="32" />
          </li>
          <For each="route" index="idx" of={routes}>
            <If
              condition={
                props.routesMap[route].path &&
                !props.routesMap[route].hidden &&
                !props.routesMap[route].notInMenu
              }
            >
              <NavLink
                key={route}
                activeClassName={classNames(theme, 'app-bar-nav-item', 'app-bar-active')}
                className={classNames(theme, 'app-bar-nav-item')}
                to={{ type: route }}
                data-title={props.routesMap[route].name}
                {...props.routesMap[route].resource && {
                  includeQuery: props.routesMap[route].resource,
                }}
                {...props.routesMap[route].path === '/' && { exact: 'exact' }}
              >
                {props.routesMap[route].name}
              </NavLink>
            </If>
          </For>
          <li
            className={classNames(theme, 'app-bar-nav-item', 'app-bar-right', 'left-margin-auto')}
          >
            <Button theme={theme} classes={['ripple', 'success']} onClick={this.gotoBuild}>
              <PlaneIcon size="1.5em" style={{ marginRight: '1em' }} />Build newsletter
            </Button>
          </li>
          <li className={classNames(theme, 'app-bar-nav-item', 'app-bar-user')}>
            <ClickAwayListener onClickAway={this.clickAwayMenu}>
              <div
                ref={node => {
                  this.userMenuNode = node
                }}
              >
                <Button theme={theme} classes="clean" onClick={this.openUserMenu}>
                  <Avatar theme={theme} cover>
                    {initials}
                  </Avatar>
                </Button>
                <If condition={this.state.userMenuOpen}>
                  <ul className={classNames(theme, 'dropdown')}>
                    <li>Welcome, {user.full_name} 😊</li>
                    <li className={theme['dropdown-link']} onClick={this.gotoAccount}>
                      Edit profile
                    </li>
                    <li className={'dropdown-spacer'} />
                    <li className={theme['dropdown-link']} onClick={this.logout}>
                      Logout
                    </li>
                  </ul>
                </If>
              </div>
            </ClickAwayListener>
          </li>
        </ul>
        <span
          ref={node => {
            this.underlineNode = node
          }}
          className={theme['app-bar-underline']}
        />
      </nav>
    )
  }
}

export default AppBar



// WEBPACK FOOTER //
// ./ui/AppBar/AppBar.js